import AccessTimeIcon from '@mui/icons-material/AccessTime';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Paper, Tooltip, Typography, useTheme } from "@mui/material";
import { ReactNode } from "react";
import DownloadMenu from '../toolbar/DownloadMenu';

interface IWidgetCardProps {
  children: ReactNode;
  title: string;
  downloadButtons?: { label: string; onClick: () => void }[];

}

const WidgetCard = ({ children, title, downloadButtons }: IWidgetCardProps) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={1}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        border: "1px solid gray",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: theme.spacing(1.5, 2),
          borderBottom: "1px solid",
          borderColor: theme.palette.divider,
          flexShrink: 0,
        }}
      >
        {/* Left */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <AccessTimeIcon fontSize="small" color="primary" />
          <Typography fontWeight={600}>{title}</Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          {downloadButtons && (
            <DownloadMenu buttons={downloadButtons} />
          )}

          <Tooltip title={title} arrow>
            <InfoOutlinedIcon fontSize="small" />
          </Tooltip>
        </Box>

      </Box>

      <Box sx={{ flex: 1, minHeight: 0, p: 1 }}>
        {children}
      </Box>
    </Paper>
  );
};

export default WidgetCard;
